import { Component, Input } from '@angular/core'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'app-loader',
	templateUrl: './Loader.Component.html',
	imports: [NgStyle],
})
export class LoaderComponent {
	@Input() public loading: boolean

	@Input() public height = '20px'
}
